import React from "react";

import { deleteFdroidRepo } from "@admin/api/fdroid";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const useDeleteFdroidRepo = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onMutate = (id: number, onSuccess: () => void) => {
        setIsLoading(true);
        void deleteFdroidRepo(id)
            .then((response) => {
                showSuccessToast(response.message);
                onSuccess();
            })
            .catch((error: Error) => showErrorToast(error.message))
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
